import type { Spec } from '../api.js';

export default function ManifestBlock({ spec }: { spec: Spec }) {
  const { manifest, will_not_touch } = spec;
  return (
    <>
      {manifest.files_create.length > 0 && (
        <div className="section">
          <h3>Creates</h3>
          <ul>
            {manifest.files_create.map((f) => (
              <li key={f} className="code">{f}</li>
            ))}
          </ul>
        </div>
      )}

      {manifest.files_modify.length > 0 && (
        <div className="section">
          <h3>Modifies</h3>
          {manifest.files_modify.map((f) => (
            <div className="modify-row" key={f.path}>
              <span className="code">{f.path}</span>
              <span className="modify-why">{f.why}</span>
            </div>
          ))}
        </div>
      )}

      {manifest.tables_create.length > 0 && (
        <div className="section">
          <h3>New tables</h3>
          <ul>
            {manifest.tables_create.map((t) => (
              <li key={t} className="code">{t}</li>
            ))}
          </ul>
        </div>
      )}

      {will_not_touch.length > 0 && (
        <div className="section will-not-touch">
          <h3>Will not touch</h3>
          <ul>
            {will_not_touch.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
